<div class="task-edit-modal">
  <h2 mat-dialog-title class="modal-title">
    <mat-icon class="me-2">{{ data.isNewTask ? "add_task" : "edit" }}</mat-icon>
    {{ data.isNewTask ? "Create New Task" : "Edit Task" }}
  </h2>

  <mat-dialog-content>
    <form [formGroup]="taskForm" class="task-form compact-inputs">
      <!-- Title -->
      <div class="form-group mb-3">
        <mat-form-field appearance="outline" floatLabel="always" class="w-100 mb-2">
          <mat-label>Enter Task Title</mat-label>
          <input matInput formControlName="title" placeholder="Enter Task Title" />
          <mat-error *ngIf="taskForm.get('title')?.hasError('required')">
            Title is required
          </mat-error>
          <mat-error *ngIf="taskForm.get('title')?.hasError('minlength')">
            Title must be at least 3 characters
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Description -->
      <div class="form-group mb-3">
        <mat-form-field appearance="outline" floatLabel="always" class="w-100 mb-2">
          <mat-label>Task Description</mat-label>
          <textarea matInput formControlName="description" rows="3" placeholder="Enter Task Description"></textarea>
        </mat-form-field>
      </div>

      <!-- Priority & Due Date -->
      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <mat-form-field appearance="outline" floatLabel="always" class="w-100 mb-2">
              <mat-label>Priority</mat-label>
              <mat-select formControlName="priority">
                <mat-option *ngFor="let option of priorityOptions" [value]="option.value">
                  <div class="d-flex align-items-center">
                    <span class="priority-dot me-2" [style.background]="option.color"></span>
                    {{ option.label }}
                  </div>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <mat-form-field appearance="outline" floatLabel="always" class="w-100 mb-2">
              <mat-label>Due Date</mat-label>
              <input #dateInput matInput type="date" formControlName="dueDate" />
              <mat-icon matSuffix class="icon-compact icon-pd-none text-secondary" (click)="dateInput.showPicker()">
                calendar_today
              </mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Assignee — searchable, application-scoped user list -->
      <div class="col-md-12">
        <div class="form-group mb-3 position-relative assignee-field">
          <mat-form-field appearance="outline" floatLabel="always" class="w-100 mb-2">
            <mat-label>Assignee</mat-label>
            <input matInput [value]="assigneeSearch" (input)="onAssigneeSearchChange($any($event.target).value)"
              (focus)="openAssigneeDropdown()" (blur)="closeAssigneeDropdown()"
              [placeholder]="isLoadingUsers ? 'Loading users…' : (appUsers.length ? 'Search and select assignee…' : 'No users found for this application')"
              [readonly]="isLoadingUsers" autocomplete="off" />
            <!-- Clear button -->
            <button *ngIf="selectedAssigneeName" mat-icon-button matSuffix type="button" class="icon-pd-none"
              (mousedown)="clearAssignee()" [matTooltip]="'Clear assignee'">
              <mat-icon class="icon-compact text-secondary">close</mat-icon>
            </button>
            <!-- Person icon when nothing selected -->
            <mat-icon *ngIf="!selectedAssigneeName" matSuffix class="text-secondary icon-compact">
              {{ isLoadingUsers ? 'hourglass_empty' : 'person_search' }}
            </mat-icon>
          </mat-form-field>

          <!-- Searchable user dropdown -->
          <div *ngIf="showAssigneeDropdown && appUsers.length > 0"
            class="assignee-dropdown shadow border rounded bg-white">
            <!-- Empty-search message -->
            <div *ngIf="filteredUsers.length === 0" class="px-3 py-2 text-muted small">
              No matching users found.
            </div>

            <!-- User list -->
            <div *ngFor="let user of filteredUsers"
              class="assignee-option px-3 py-2 d-flex align-items-center gap-2 cursor-pointer"
              (mousedown)="selectAssignee(user)">
              <!-- Avatar initials badge -->
              <span
                class="assignee-avatar bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center">
                {{ (user.userFirstname || '?').charAt(0).toUpperCase() }}
              </span>
              <div>
                <div class="fw-semibold small">{{ user.userFirstname }}</div>
                <div class="text-muted" style="font-size:0.75rem">{{ user.email }}</div>
              </div>
              <!-- Tick if already selected -->
              <mat-icon *ngIf="selectedAssigneeName === user.userFirstname" class="ms-auto text-success"
                style="font-size:16px;width:16px;height:16px">check</mat-icon>
            </div>
          </div>
        </div>
      </div>

      <!-- Labels -->
      <div class="col-md-12">
        <div class="form-group mb-3">
          <mat-form-field appearance="outline" floatLabel="always" class="w-100">
            <mat-label>Labels (comma separated)</mat-label>
            <input matInput formControlName="labelsInput" placeholder="Eg. Research, Development, etc." />
          </mat-form-field>
          <small class="text-muted">* Separate multiple labels with commas</small>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions">
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!taskForm.valid" class="save-btn">
      <mat-icon>{{ data.isNewTask ? "add" : "save" }}</mat-icon>
      {{ data.isNewTask ? "Create Task" : "Save Changes" }}
    </button>

    <button mat-stroked-button color="warn" (click)="onCancel()">
      <mat-icon class="me-1">close</mat-icon>
      <span>Cancel</span>
    </button>
  </mat-dialog-actions>
</div>